import { combineReducers } from "redux";
import { authReducer } from "./Login/login.reducers";


export default combineReducers({
  auth: authReducer,

});
